import { classNames } from "helpers/themeHelpers";
import { gtmSubCategoryLatestAds } from "GTMs/actions/postViewActions";
import { useTheme } from "styled-components";
import { IWidget } from "../../../../types/home";
import { FC, Fragment } from "react";

interface IProps {
  widget: IWidget;
}

const HomeWidgetTags: FC<IProps> = ({ widget }) => {
  const { isDesktop, isMobile } = useTheme();
  return (
    <Fragment>
      {widget?.sub_links && widget?.sub_links?.length > 0 ? (
        <div
          {...classNames(
            "flex gap-10 homeFacetsSource",
            isDesktop && "flexWrap mt-16 overflowHidden",
            isMobile && "flexNoWrap mt-8 noWrap overflowX-scroll"
          )}
        >
          {widget?.sub_links?.map((tag, index) => {
            return (
              <a
                key={index}
                href={tag?.weblink}
                className="homeCpsSearchSource block center grayBg blackColor p-8 radius-8 blueHoverBg"
                onClick={() =>
                  gtmSubCategoryLatestAds(
                    widget?.gtm_config?.sub_links?.eventAction,
                    widget?.gtm_config?.sub_links?.eventLabel,
                    {
                      Category: widget?.category_reporting_name,
                      SubCategory: tag?.subcategory_reporting_name,
                    }
                  )
                }
              >
                {tag.label}
              </a>
            );
          })}
        </div>
      ) : null}
    </Fragment>
  );
};

export default HomeWidgetTags;
